import AddIcon from '@assets/svg/add-menu.svg';
import SerachIcon from '@assets/svg/table-search.svg';
import { useState } from '@hookstate/core';
import { NavigationContext } from '@layout/navigation/navigation';

import { DirectionCustomStatustypes } from '@pages/ConfigurationPage/Components/FieldsManagement/Components/AssetStatus/Components/CustomStatus/CustomStatus.query';
import {
  AddButton,
  AddButtonText,
  Buttons,
  Container,
  Header,
  InputContainer,
  InputSearch,
  SearchIconContainer,
  Title,
  Wrapper,
} from '@pages/ConfigurationPage/Components/FieldsManagement/Components/AssetStatus/Components/CustomStatus/CustomStatus.styles';

import { getStudioCustomField } from '@services/queries/studios';
import { useContext, useState as classicUseState } from 'react';

import { useQuery } from 'react-query';

import { CustomFieldsTable } from './components';
import { CreateCustomField } from './components/CreateCustomField/CreateCustomField';

export interface IFilter {
  sort?: string;
  direction?: 'ASC' | 'DESC' | undefined;
}

export type SortCustomFieldTypes =
  | 'customField.name'
  | 'customField.description'
  | 'customField.type'
  | 'selectable_value.value'
  | 'customField.defaultValue'
  | 'customField.showOnOnboard'
  | 'customField.isUnique'
  | undefined;

const CustomFieldsTab = () => {
  const { studioId, role } = useContext(NavigationContext);
  const sort = useState<SortCustomFieldTypes>(undefined);
  const direction = useState<DirectionCustomStatustypes>(undefined);
  const open = useState(false);
  const [searchTextModel, setSearchTextModel] = classicUseState('');
  const { data, isLoading, isError } = useQuery(
    ['studios', studioId, 'customField', sort.get(), direction.get()],
    () =>
      getStudioCustomField({
        id: studioId,
        sort: sort.get(),
        direction: direction.get(),
      }),
  );
  return (
    <Container>
      <Header>
        <Wrapper>
          <Title>Here you can manage and configure your custom fields</Title>
        </Wrapper>
        <Buttons>
          <InputContainer>
            <SearchIconContainer>
              <img src={SerachIcon} alt="search" />
            </SearchIconContainer>
            <InputSearch
              placeholder="Search"
              value={searchTextModel}
              onChange={e => setSearchTextModel(e.target.value)}
              autoFocus
            />
          </InputContainer>

          {role === 'admin' ? (
            <AddButton type="button" onClick={() => open.set(true)}>
              <img src={AddIcon} alt="add status" />
              <AddButtonText>Add Custom Field</AddButtonText>
            </AddButton>
          ) : (
            <div />
          )}
        </Buttons>
      </Header>

      <CustomFieldsTable
        customFields={data}
        isLoading={isLoading}
        isError={isError}
        searchTextModel={searchTextModel}
        directionDb={direction}
        sort={sort}
      />

      <CreateCustomField open={open} data={data} />
    </Container>
  );
};

export { CustomFieldsTab };
